/** Nom affiché publiquement : pseudo si défini, sinon nom complet. */
export function displayName(user) {
  if (!user) return "";
  const pseudo = (user.pseudo || "").trim();
  if (pseudo) return pseudo;
  return (user.name || "").trim() || user.email?.split("@")[0] || "Joueur";
}
